import 'katex/dist/katex.min.css'
import MarkdownPage from "./MarkdownPage";

type ManageTelegramProps = {} & React.HTMLAttributes<HTMLDivElement>;

export default function ManageTelegramPage({ children, ...props }: ManageTelegramProps) {
  return (
    <MarkdownPage group={"public"} message={"telegram"} isEditable={true}></MarkdownPage>
  )
}
